import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useBEOController } from "@context/BeoContext";
import { getUserName } from "@utils/auth";
import { memo } from "react";
/**
 * Footer component displays the application's copyright information and a welcome message
 * personalized with the logged-in user's first name, if available.
 * It is memoized for performance optimization.
 *
 * @component
 * @author niyas.shajahan
 * @since 2025-06-19
 */
var Footer = function () {
    /**
     * Retrieves context from useBEOController, typically for user information.
     * @type {Array<object>}
     */
    var context = useBEOController()[0];
    /**
     * Gets the current year for copyright display.
     * @type {number}
     */
    var currentYear = new Date().getFullYear();
    return (_jsx("footer", { role: "contentinfo" // Semantic role for accessibility
        , className: "w-full h-auto bg-[var(--primary-color)] text-[var(--primary-color-text)] flex items-center justify-center py-2 px-4 sm:h-[32px] md:h-[25px] md:fixed md:bottom-0 md:left-0 z-50", children: _jsxs("div", { className: "text-xs md:text-sm text-center flex flex-col sm:flex-row items-center gap-2", children: [_jsxs("span", { children: ["\u00A9 ", currentYear, " Beo Software. All rights reserved."] }), getUserName() && (_jsxs(_Fragment, { children: [_jsx("span", { className: "hidden sm:inline", children: "|" }), " ", _jsxs("span", { "data-testid": "welcome-message", className: "text-center", children: ["Welcome,", " ", _jsx("span", { className: "font-semibold text-[var(--accent-color)] animate-pulse", children: getUserName() }), "!"] })] }))] }) }));
};
export default memo(Footer); // Memoize the component for performance
